import { createUserManager } from 'redux-oidc';
import { WebStorageStateStore } from 'oidc-client';

import { OIDC_CLIENT_ID, OIDC_AUTHORITY } from '../env';

const location = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;

const userManager = createUserManager({
  // Who to contact, and how to identify ourselves
  authority: OIDC_AUTHORITY,
  client_id: OIDC_CLIENT_ID,
  // What access we are requesting
  scope: 'openid profile',
  // Where (uris) and how the OIDC server should respond
  redirect_uri: `${location}/callback/login`,
  post_logout_redirect_uri: `${location}/callback/logout`,
  silent_redirect_uri: `${location}/callback/renew`, // since this is part of the main app bundle (due to using CRA), renews will cause the browser to re-download the whole bundle
  response_type: 'code',
  // What we should do with the response
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // If and how long in advance to expiration we should refresh to token
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTime: 60,
});

export default userManager;
